
import "../CreateClient/CreateClient.css";
import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../context";
import { business, radioType } from "../../interfaces";
import StarRateIcon from "@mui/icons-material/StarRate";

type propsData = {
    otherBusinessType: string,
    otherTerm: string,
    setOtherBusinessType: (newOtherBusinessType: string) => void,
    setOtherTerm: (newOtherTerm: string) => void,
    client: any
}

function BusinessTypeAndTerm(props: propsData){

    const {
        businessType,
        setBusinessType,
        mortgageLogoType,
        setMortgageLogoType
    } = useGlobalContext();

    const {
        otherBusinessType,
        setOtherBusinessType,
        otherTerm,
        setOtherTerm,
        client
    } = props;

    const [activeBusiness, setActiveBusiness] = useState<business | undefined>();
    const [activeTerm, setActiveTerm] = useState<string>("");
    const [activeCategory, setActiveCategory] = useState<string>("");
    const [activeLogoType, setActiveLogoType] = useState<string>("");

    const findClientBusinessType = (type: string, category: string, term: string) => {
        const activeBusiness: business | undefined = businessType.find(item => item.title === type);
        if (activeBusiness) {
            setBusinessType((businessType: business[]) => businessType.map((item) => {
                if (item.id === activeBusiness.id) {
                    const activeTerm: radioType | undefined = item.terms.find((item:radioType) => item.title === term);
                    const activeCategory: string | undefined = item.categories?.filter((item: radioType) => category.includes(item.title)).map(elem => elem.title).join(', ');
                    if (activeTerm) {
                        return activeCategory ? {
                            ...item,
                            active: true,
                            terms: item.terms.map((term)=> term.id === activeTerm.id ? { ...term, active: true } : { ...term, active: false }),
                            categories: item.categories?.map(ctg => activeCategory.includes(ctg.title) ? { ...ctg, active: true } : { ...ctg, active: false })
                        }
                        :
                        {
                            ...item,
                            active: true,
                            terms: item.terms.map((term)=> term.id === activeTerm.id ? { ...term, active: true } : { ...term, active: false })
                        }
                    }
                    else {
                        setOtherTerm(term);
                        return activeCategory ? {
                            ...item,
                            active: true,
                            terms: item.terms.map((term) => term.title === "Other" ? { ...term, active: true } : { ...term, active: false }),
                            categories: item.categories?.map(ctg => activeCategory.includes(ctg.title) ? { ...ctg, active: true } : { ...ctg, active: false })
                        }
                        :
                        {
                            ...item,
                            active: true,
                            terms: item.terms.map((term) => term.title === "Other" ? { ...term, active: true } : { ...term, active: false })
                        }
                    }
                }
                else {
                    return { ...item, active: false };
                }
            }));
        }
        else {
            setOtherBusinessType(type);
            setOtherTerm(term);
            setBusinessType((businessType: business[]) => businessType.map((item) => item.title === "Other" ? { ...item, active: true, terms: [{ ...item.terms[0], active: true }] } : { ...item, active: false }));
        }
    }

    const findClientLogoType = (logoType: string ) => {
        setMortgageLogoType(type => type.map(item => item.title === logoType ? { ...item, active: true } : { ...item, active: false }));
    }

    useEffect(() => {
        if (client) {
            findClientBusinessType(client.businessData.businessType, client.businessData.businessSubtype, client.businessData.termForBusiness);
            findClientLogoType(client.businessData.mortgageLogo);
        }
    }, [client])

    useEffect((): void => {
        const activeBusiness: business | undefined = businessType.find(item => item.active);
        if (activeBusiness) {
            setActiveBusiness(activeBusiness);
            const findActiveTerm: radioType | undefined = activeBusiness.terms.find((item: radioType) => item.active);
            const findActiveCategory: radioType[] | undefined = activeBusiness.categories?.filter((item: radioType) => item.active);
            if (findActiveTerm) {
                setActiveTerm(findActiveTerm.title)
            }
            if (findActiveCategory) {
                setActiveCategory(findActiveCategory.map(elem => elem.title).join(", "))
            }
        }
    }, [businessType])

    useEffect(() => {
        const activeLogo = mortgageLogoType.find(item => item.active);
        if (activeLogo) setActiveLogoType(activeLogo.title);
        else setActiveLogoType("");
    }, [mortgageLogoType]);

    const handleChange = (item: business): void => {
        setBusinessType((businessType: business[]) => businessType.map((type: business) => type.id === item.id ? { ...type, active: true } : { ...type, active: false }));
        setOtherBusinessType("");
        setOtherTerm("");
    }

    const handleTerm = (concretTerm: radioType): void => {
        setBusinessType((businessType: business[]) => businessType.map((type: business) => {
            if (type.title === activeBusiness?.title) {
                return {
                    ...type,
                    terms: type.terms.map((term: radioType) => term.id === concretTerm.id ? { ...term, active: true } : { ...term, active: false }),
                };
            }
            else {
                return { ...type };
            }
        }));
        setOtherTerm("");
    }

    const handleCategory = (category: radioType) => {
        setBusinessType((businessType: business[]) => businessType.map((type: business) => {
            if (type.title === activeBusiness?.title) {
                return {
                    ...type,
                    categories: type.categories?.map((ctg: radioType) => ctg.id === category.id ? { ...ctg, active: !ctg.active } : { ...ctg }),
                };
            }
            else {
                return { ...type };
            }
        }));
    }

    const handleLogoType = (logoType: radioType): void => {
        setMortgageLogoType(mortgageLogoType => mortgageLogoType.map(item => item.id === logoType.id ? { ...item, active: true } : { ...item, active: false }))
    }

    return (
        <div className = "BusinessTypeAndTerm" style = {{ margin: "30px 0 0 0" }}>
            <div className = "createClient-form-package">
                <label className = "required"> Business Type <StarRateIcon style = {{ color: "red", fontSize: "10px" }}/>
                </label>
            </div>
            {
                businessType.map((item: business, index: number) => {
                    if (item.title !== "Other") {
                        return <div
                            className = "form-package-box" key = {index}
                            onClick = { () => handleChange(item) }
                        >
                            <input
                                className = "packageOption"
                                type = "radio"
                                checked = { item.title === activeBusiness?.title }
                                name = { "business" }
                            />
                            <label>{ item.title }</label>
                        </div>
                    }
                    else {
                        return (
                            <div
                                className = "form-package-box"
                                key = { index }
                                onClick = { () => handleChange(item) }
                            >
                                <input
                                    className = "packageOption"
                                    type = "radio"
                                    checked = { item.title === activeBusiness?.title }
                                    name = { "business" }
                                />
                                {
                                    activeBusiness?.title === "Other" ?
                                        <input
                                            type = "text"
                                            placeholder = "Other"
                                            value = { otherBusinessType }
                                            onChange = { e => setOtherBusinessType(e.target.value) }
                                            className = "custom-package-input"
                                        />
                                        :
                                        <label htmlFor = "socialOther">{ item.title }</label>
                                }
                            </div>
                        )
                    }
                })
            }
            {
                activeBusiness?.title !== "Other" && activeBusiness?.categories ?
                    <>
                        <div
                            className = "createClient-form-package"
                            style = {{ margin: "30px 0 0 0" }}
                        >
                            <label className = "required">
                                Business Category<StarRateIcon
                                style = {{
                                    color: "red",
                                    fontSize: "10px"
                                }}
                            />
                            </label>
                        </div>
                        {
                            businessType
                                .find((item: business) => item.title === activeBusiness?.title)?.categories?.map((ctg: radioType) => {
                                    return <div
                                        className = "form-package-box" key = { ctg.id }
                                        onClick = {() => handleCategory(ctg)}
                                    >
                                        <input
                                            className = "packageOption"
                                            type = "checkbox"
                                            style = {{ display: 'inline-block' }}
                                            checked = { activeCategory.includes(ctg.title) }
                                            name = { "category" }
                                        />
                                        <label>{ ctg.title }</label>
                                    </div>
                                })
                        }
                    </>
                    :
                    null
            }
            {
                activeBusiness?.title !== "Other" ?
                    <>
                        <div
                            className = "createClient-form-package"
                            style = {{ margin: "30px 0 0 0" }}
                        >
                            <label className = "required">
                                Term to be used for { activeBusiness?.title }<StarRateIcon
                                style = {{
                                    color: "red",
                                    fontSize: "10px"
                                }}
                            />
                            </label>
                        </div>
                        {
                            businessType
                                .find((item: business) => item.title === activeBusiness?.title)?.terms
                                .map((term: radioType) => {
                                    return <div
                                        className = "form-package-box" key = { term.id }
                                        onClick = {() => handleTerm(term)}
                                    >
                                        <input
                                            className = "packageOption"
                                            type = "radio"
                                            checked = { term.title === activeTerm }
                                            name = { "term" }
                                        />
                                        {
                                            term.title === 'Other' && activeTerm === 'Other' ?
                                                <input
                                                    type = "text"
                                                    placeholder = "Other term"
                                                    value = { otherTerm }
                                                    onChange = { e => setOtherTerm(e.target.value) }
                                                    className = "custom-package-input"
                                                />
                                                :
                                                <label htmlFor = "socialOther">{ term.title }</label>
                                        }
                                    </div>
                                })
                        }
                    </>
                    :
                    <>
                        <div className="createClient-form-package" style = {{ margin: "30px 0 0 0" }}>
                            <label className = "required">
                                Term to be used for { activeBusiness.title } Business Type<StarRateIcon
                                style = {{
                                    color: "red",
                                    fontSize: "10px"
                                }}
                            />
                            </label>
                        </div>
                        <input
                            type = "text"
                            placeholder = "Other term"
                            value = { otherTerm }
                            onChange = {e => setOtherTerm(e.target.value)}
                            className = "custom-package-input"
                            style = {{
                                margin: "20px 0 0 30px"
                            }}
                        />
                    </>
            }
            {
                activeBusiness?.title === "Mortgage" ?
                    <>
                        <div className="createClient-form-package" style = {{margin: "30px 0 0 0"}}>
                            <label className="required">Choose which Equal Housing Logo do you want to use in your branding materials:<StarRateIcon
                                style = {{color: "red", fontSize: "10px"}}/>
                            </label>
                        </div>
                        {
                            mortgageLogoType.map((item: radioType) =>
                                <div
                                    className = "form-package-box"
                                    key = { item.id }
                                    onClick = {() => handleLogoType(item)}
                                >
                                    <input
                                        className = "packageOption"
                                        type = "radio"
                                        checked = { item.title === activeLogoType }
                                        name = {"logoType"}
                                    />
                                    <label >{ item.title }</label>
                                </div>
                            )
                        }
                    </>
                : null
            }
        </div>
    )
}

export default BusinessTypeAndTerm;
